















































































































import Vue from 'vue';
import { Component, Emit, Model, Prop, Watch, Ref } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import * as rules from '@/rules';
import { Auth } from 'aws-amplify';
import Users from '@/store/modules/Users';
import { NotificationEventBus } from '@/EventBus';

const users = getModule(Users);

@Component({
    components: {},
})
export default class ChangePasswordDialog extends Vue {
    private open = false;
    private showPassword = false;
    private form = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    };

    @Ref()
    private formRef: HTMLFormElement;

    private sending = false;

    private error = null;

    private rules = {
        required: rules.REQUIRED,
        passwordRequirements: rules.PASSWORD_STRENGTH,
        passwordMatch: (v: string) =>
            (!!v && v == this.form.newPassword) || 'Passwords do not match.',
    };
    get authUser() {
        return users.currentAuthUser;
    }
    private cancel() {
        this.form.oldPassword = '';
        this.form.newPassword = '';
        this.form.confirmPassword = '';
        this.formRef.reset();
        this.open = false;
    }
    private async save() {
        await this.changePassword();
    }

    private async changePassword() {
        if (!this.formRef.validate()) {
            return;
        }
        this.sending = true;
        Auth.changePassword(this.authUser, this.form.oldPassword, this.form.newPassword)
            .then((result) => {
                this.sending = false;
                NotificationEventBus.emitNotification('complete-snackbar', {
                    message: 'Password Changed',
                });
                this.formRef.reset();

                this.open = false;
            })
            .catch((err) => {
                // this.sending = false;
                // this.error = err;
                // console.log(err.response.status);
                this.sending = false;
                if (err.hasOwnProperty('message')) {
                    console.log(err.message);
                    NotificationEventBus.emitFailedMessage(err);
                }
            });
    }
}
